import React, { useRef, useState, useMemo, useEffect, Fragment } from 'react';
// import { useMatomo } from '@datapunt/matomo-tracker-react'
import Map, { Marker, Popup, NavigationControl, GeolocateControl } from 'react-map-gl';

import maplibregl from 'maplibre-gl';
import "maplibre-gl/dist/maplibre-gl.css";

import RundedrehenMapPin from './rundedrehen-map-pin';
import RundedrehenMapListItemClubEventPopup from './rundedrehen-map-list-item-club-event-popup';
import RundedrehenMapListItemPlacePopup from './rundedrehen-map-list-item-place-popup';

'use strict';

function RundedrehenMapMap({ mapData, activeItems, setActive, visibleItems, itemType, setVisible, loading }) {
  const mapRef = useRef(null);
  const [popupItem, setPopupItem] = useState(null);
  const [mapInitialized, setMapInitialized] = useState(false);
  // const { trackEvent } = useMatomo();

  let coords = [];
  let markersData = [];

  const mapItemsList = document.querySelector('.map-items-list');
  const header = document.querySelector('.header');

  useEffect(() => {
    setVisible(null);
    setPopupItem(null);
    // if (!loading) {
    // }
    // setTimeout(() => {
    //   resetMap(true);
    // }, 500);
  }, [loading]);

  useEffect(() => {
    if (mapInitialized) {
      updateList();
    }
  }, [mapData]);

  const mapLoadHandler = () => {
    setMapInitialized(true);
    setTimeout(() => {
      resetMap();
    }, 1000);
  }

  const resetMap = (showAll = false) => {
    setPopupItem(null);

    // // fit all markers in map
    // let coordinates = coords;
    // let bounds = coordinates.reduce(function (bounds, coord) {
    //   return bounds.extend(coord);
    // }, new maplibregl.LngLatBounds(coordinates[0], coordinates[0]));

    // set DACH region in bound
    const sw = new maplibregl.LngLat(3.6, 43.5);
    const ne = new maplibregl.LngLat(20, 55);
    const bounds = new maplibregl.LngLatBounds(sw, ne);

    if (mapItemsList && header && mapRef.current) {
      mapRef.current.fitBounds(bounds, {
        padding: {
          top: window.innerWidth > 1024 ? (50 + header.clientHeight) : 20,
          bottom: window.innerWidth > 1024 ? 50 : 20,
          left: window.innerWidth > 1024 ? (50 + mapItemsList.clientWidth) : 20,
          right: window.innerWidth > 1024 ? 50 : 20,
        }
      }, { showAll: showAll });
    }
  }


  const mapZoomEndHandler = (event) => {
    updateList(event.showAll)
    // console.log(mapRef.current.getZoom())
  }


  const mapMoveHandler = (event) => {
    if (mapInitialized) {
      updateList(event.showAll)
    }
  }


  const updateList = (showAll) => {
    if (!showAll) {
      // filter markers by bounds
      let mapBoxBound = mapRef.current.getBounds();

      // get bounds without map items list
      if (mapItemsList) {
        const mapItemsListRect = mapItemsList.getBoundingClientRect();
        if (window.innerWidth >= 1024) {
          const sw = mapRef.current.unproject({x: mapItemsListRect.right, y: window.innerHeight});
          const ne = mapRef.current.unproject({x: window.innerWidth, y: 0});
          mapBoxBound = new maplibregl.LngLatBounds([sw, ne]);
        }
        else if (window.innerWidth < 1024 && window.innerWidth >= 768) {
          const sw = mapRef.current.unproject({ x: 0, y: mapItemsListRect.top });
          const ne = mapRef.current.unproject({ x: window.innerWidth, y: 0 });
          mapBoxBound = new maplibregl.LngLatBounds([sw, ne]);
        }
      }

      // TODO: use project / unproject methods to get bounds from pixels
      const markers = markersData.filter(
        markerData => mapBoxBound.contains(markerData.coordinates)
      );

      let tmp = [];
      markers.forEach(marker => {
        tmp = tmp.concat(marker.ids);
      });

      setVisible(tmp);
    }
    else {
      setVisible(null);
    }
  }


  return <div className="
    md:absolute md:top-0 md:left-0
    w-full h-full
    z-5
  ">

    <Map
      mapLib={maplibregl}
      // mapStyle={`https://api.maptiler.com/maps/01bd8133-1ab3-4259-914f-a03bd650519f/style.json?key=LMeV7r37D6eeoQOE2Q0n`}
      mapStyle={`/mapdata/rundedrehen_cyclingclub.json`}
      showTileBoundaries={true}
      initialViewState={{
        // longitude: 8.278572,
        // latitude: 49.99963,
        minZoom: 1,
        maxZoom: 14.95,
        bounds: [[3.6, 43.5], [20, 55]],
        scrollZoom: true,
        dragRotate: false,
        pitchWithRotate: false,
        minPitch: 0,
        maxPitch: 0,
      }}
      ref={mapRef}
      onLoad={() => mapLoadHandler()}
      onMove={(event) => mapMoveHandler(event)}
      onZoomEnd={(event) => mapZoomEndHandler(event)}
    >

      <NavigationControl
        showCompass={false}
      />
      <GeolocateControl
        fitBoundsOptions={{maxZoom: 9}}
      />

      {
        mapData.markers.features.map((item, idx) => {
          // save coords for initial map bounds
          coords.push([item.geometry.coordinates[0], item.geometry.coordinates[1]]);
          markersData.push({
            'ids': item.properties.ids,
            'coordinates': [item.geometry.coordinates[0], item.geometry.coordinates[1]],
          });

          return <Marker
            key={idx}
            longitude={item.geometry.coordinates[0]}
            latitude={item.geometry.coordinates[1]}
            anchor="bottom"
            onClick={(e) => {
              e.originalEvent.stopPropagation();
              setPopupItem(item);
              // trackEvent({ category: 'map', action: 'click pin', name: item.properties.type + ' ' + item.properties.category + ' ' + item.properties.label, value: item.properties.id });
            }}
            style={{
              zIndex: (item.properties.ids.filter(value => activeItems.includes(value)).length) ? 100 : 20,
            }}
          >
            <RundedrehenMapPin
              item={item}
              setActive={setActive}
              activeItems={activeItems}
            />
          </Marker>
        })
      }

      {popupItem && (
        <Popup
          anchor="top"
          longitude={Number(popupItem.geometry.coordinates[0])}
          latitude={Number(popupItem.geometry.coordinates[1])}
          offset={{
            bottom: [10, 30],
          }}
          onClose={() => setPopupItem(null)}
        >
          <Fragment>
            { popupItem.properties.type == 'club_event' && <RundedrehenMapListItemClubEventPopup item={popupItem.properties} /> }
            { popupItem.properties.type == 'place' && <RundedrehenMapListItemPlacePopup item={popupItem.properties} /> }
          </Fragment>
        </Popup>
      )}

    </Map>
  </div>;
}


export default RundedrehenMapMap;
